import { render, staticRenderFns } from "./StatusesEditor.vue?vue&type=template&id=1ecd7702&"
import script from "./StatusesEditor.vue?vue&type=script&lang=js&"
export * from "./StatusesEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports